export const LEAD_STATUS_PENDING=1;
export const LEAD_STATUS_VERIFIED=2;
export const LEAD_STATUS_REJECTED=3;
export const LEAD_STATUS_HOLD=4;

export const LEAD_STATUS={
    1:"Pending",
    2:"Verified",
    3:"Rejected",
    4:"Hold"
};

export const REJECTION_REPEATED_ENQUIRY = 1;
export const REJECTION_CONFIRMATION_PENDING = 2;
export const REJECTION_NOT_PICKED_WHATSAPP_DROP = 3;
export const REJECTION_NO_ENQUIRY_RAISED = 4;
export const REJECTION_QUOTATION_REQUIREMENT = 5;
export const REJECTION_TESTING = 6;
export const REJECTION_WRONG_ENQUIRY = 7;
export const REJECTION_CUSTOMER_ENQUIRY = 8;
export const REJECTION_WRONG_NUMBER = 9;
export const REJECTION_LOST_TO_COMPETITOR = 10;
export const REJECTION_CALL_DISCONNECTED = 11;
export const REJECTION_CALL_BACK = 12;
export const REJECTION_DROP = 13;
export const REJECTION_FIELD_VISIT_DONE = 14;
export const REJECTION_CITY_NOT_SERVICEABLE = 15;
export const REJECTION_EXISTING_CUSTOMER=16;
export const REJECTION_OTHER = 17;

export const REJECTION_REASONS = {
    1: "Repetitive Enquiry",
    2: "Confirmation Pending",
    3: "Not Picked/Switched Off-Whatsapp Drop",
    4: "No Enquiry Raised",
    5: "Quotation Requirement",
    6: "Testing",
    7: "Wrong Enquiry",
    8: "Customer Enquiry",
    9: "Wrong Number",
    10: "Requirement completed/Lost to Competitor",
    11: "Call Disconnected",
    12: "Call Back",
    13: "Drop",
    14: "Field visit already done",
    15: "City not serviceable",
    16: "Existing Park+ Customer",
    17: "Other",
};

export const HOLD_REPEATED_ENQUIRY = 1;
export const HOLD_CONFIRMATION_PENDING = 2;
export const HOLD_NOT_PICKED_WHATSAPP_DROP = 3;
export const HOLD_NO_ENQUIRY_RAISED = 4;
export const HOLD_QUOTATION_REQUIREMENT = 5;
export const HOLD_QUOTATION_SHARED = 6;
export const HOLD_TESTING = 7;
export const HOLD_WRONG_ENQUIRY = 8;
export const HOLD_CUSTOMER_ENQUIRY = 9;
export const HOLD_WRONG_NUMBER = 10;
export const HOLD_LOST_TO_COMPETITOR = 11;
export const HOLD_CALL_DISCONNECTED = 12;
export const HOLD_CALL_BACK = 13;
export const HOLD_DROP = 14;
export const HOLD_FIELD_VISIT_DONE = 15;
export const HOLD_CITY_NOT_SERVICEABLE = 16;
export const HOLD_EXISTING_CUSTOMER=17
export const HOLD_OTHER = 18;

export const HOLD_REASONS = {
    1: "Repetitive Enquiry",
    2: "Confirmation Pending",
    3: "Not Picked/Switched Off-Whatsapp Drop",
    4: "No Enquiry Raised",
    5: "Quotation Requirement",
    6: "Quotation shared to client",
    7: "Testing",
    8: "Wrong Enquiry",
    9: "Customer Enquiry",
    10: "Wrong Number",
    11: "Requirement completed/Lost to Competitor",
    12: "Call Disconnected",
    13: "Call Back",
    14: "Drop",
    15: "Field visit already done",
    16: "City not serviceable",
    17: "Existing Park+ Customer",
    18: "Other",
};
